import ContentCard from "../../ui/ContentCard";
import styles from "../../styles/Components/bot/CommunityBots.module.css";
import { RiGlobalLine } from "react-icons/ri";
import ContentCardTitle from "../../ui/ContentCardTitle";
import { useSelector } from "react-redux";
import CommunityBotsContent from "../../shared/CommunityBotsContent";

function CommunityBots() {
  const {
    dashboard: { botInfoStatus, communityBots },
  } = useSelector((state) => state);
  return (
    <ContentCard className={styles.container} id="community-bots">
      <div className={styles.header}>
        <div className={styles.leftHeader}>
          <div className={styles.botIcon}>
            <RiGlobalLine color="#0D4AF9" size={23} />
          </div>
          <ContentCardTitle
            title="Top Community Bots"
            style={{ display: "inline-block" }}
          />
        </div>
      </div>

      <CommunityBotsContent />
    </ContentCard>
  );
}

export default CommunityBots;
